import { Shape, ShapeGeometry } from 'three'
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js'

const shape1_1 = new Shape()

shape1_1.moveTo(-4.800, 24.200)

shape1_1.bezierCurveTo(
  -6.800, 23.900,
  -8.700, 23.300,
  -10.100, 21.600
)

shape1_1.bezierCurveTo(
  -10.800, 20.800,
  -11.500, 20.000,
  -12.300, 19.200
)

shape1_1.bezierCurveTo(
  -14.100, 24.500,
  -12.700, 28.500,
  -7.900, 31.300
)

shape1_1.bezierCurveTo(
  -9.600, 31.000,
  -11.200, 30.800,
  -13.200, 30.500
)

shape1_1.bezierCurveTo(
  -11.600, 33.200,
  -10.100, 35.700,
  -8.600, 38.100
)

shape1_1.bezierCurveTo(
  -8.600, 38.100,
  -8.000, 38.100,
  -7.900, 38.100
)

shape1_1.bezierCurveTo(
  -7.500, 37.700,
  -7.200, 37.300,
  -6.800, 36.800
)

shape1_1.bezierCurveTo(
  -5.100, 38.900,
  -3.600, 40.700,
  -2.000, 42.600
)

shape1_1.bezierCurveTo(
  -1.300, 43.400,
  -0.700, 44.200,
  -0.100, 45.000
)

shape1_1.lineTo(-0.100, 24.600)

shape1_1.bezierCurveTo(
  -1.700, 24.600,
  -3.300, 24.400,
  -4.900, 24.200
)

shape1_1.lineTo(-4.900, 24.200)
shape1_1.closePath()

const shape2_1 = new Shape()

shape2_1.moveTo(-4.000, -20.400)

shape2_1.bezierCurveTo(
  -2.700, -19.600,
  -1.300, -19.200,
  0.000, -19.200
)

shape2_1.lineTo(0.000, -32.200)

shape2_1.bezierCurveTo(
  -1.400, -32.200,
  -2.800, -32.200,
  -4.100, -32.100
)

shape2_1.bezierCurveTo(
  -6.300, -32.100,
  -8.500, -32.000,
  -10.600, -31.900
)

shape2_1.bezierCurveTo(
  -11.000, -31.900,
  -11.500, -31.800,
  -11.900, -31.700
)

shape2_1.bezierCurveTo(
  -13.100, -31.700,
  -14.300, -31.700,
  -15.100, -32.900
)

shape2_1.bezierCurveTo(
  -15.800, -33.900,
  -16.400, -35.100,
  -17.300, -36.000
)

shape2_1.bezierCurveTo(
  -20.200, -38.900,
  -23.800, -40.000,
  -27.800, -38.900
)

shape2_1.bezierCurveTo(
  -29.900, -38.400,
  -31.800, -37.300,
  -33.200, -35.600
)

shape2_1.bezierCurveTo(
  -34.700, -33.800,
  -35.400, -31.800,
  -35.400, -29.500
)

shape2_1.lineTo(-29.400, -29.500)

shape2_1.bezierCurveTo(
  -29.400, -30.200,
  -29.200, -30.800,
  -28.800, -31.500
)

shape2_1.bezierCurveTo(
  -27.800, -33.200,
  -25.000, -34.200,
  -22.800, -32.900
)

shape2_1.bezierCurveTo(
  -21.300, -32.000,
  -20.700, -30.700,
  -20.700, -29.500
)

shape2_1.lineTo(-16.400, -29.500)
shape2_1.lineTo(-16.400, -14.100)

shape2_1.bezierCurveTo(
  -13.800, -11.800,
  -11.200, -9.500,
  -8.600, -7.200
)

shape2_1.lineTo(-8.600, -7.000)

shape2_1.bezierCurveTo(
  -11.700, -7.000,
  -14.800, -7.000,
  -17.800, -7.000
)

shape2_1.bezierCurveTo(
  -20.800, -7.000,
  -20.400, -8.600,
  -20.700, -10.000
)

shape2_1.lineTo(-27.700, -10.000)

shape2_1.bezierCurveTo(
  -27.700, -6.600,
  -27.700, -3.300,
  -27.500, 0.000
)

shape2_1.bezierCurveTo(
  -27.400, 2.200,
  -27.000, 4.300,
  -26.700, 6.500
)

shape2_1.bezierCurveTo(
  -26.700, 7.100,
  -26.300, 7.800,
  -26.100, 8.400
)

shape2_1.lineTo(-25.900, 8.400)

shape2_1.bezierCurveTo(
  -25.000, 5.200,
  -24.100, 2.000,
  -23.300, -1.200
)

shape2_1.lineTo(-23.000, -1.200)

shape2_1.bezierCurveTo(
  -22.200, 2.100,
  -21.400, 5.400,
  -20.600, 8.900
)

shape2_1.bezierCurveTo(
  -19.300, 7.800,
  -18.200, 6.900,
  -17.100, 5.900
)

shape2_1.bezierCurveTo(
  -17.100, 5.900,
  -16.900, 5.600,
  -16.700, 5.500
)

shape2_1.lineTo(-16.500, 5.500)

shape2_1.bezierCurveTo(
  -16.500, 5.700,
  -16.700, 5.800,
  -16.800, 6.000
)

shape2_1.lineTo(-16.800, 7.700)

shape2_1.bezierCurveTo(
  -17.200, 9.400,
  -16.800, 11.000,
  -16.400, 12.600
)

shape2_1.bezierCurveTo(
  -16.000, 14.000,
  -15.300, 15.200,
  -13.800, 15.800
)

shape2_1.bezierCurveTo(
  -13.800, 15.300,
  -13.600, 14.900,
  -13.500, 14.500
)

shape2_1.bezierCurveTo(
  -12.500, 10.500,
  -10.400, 7.600,
  -5.900, 7.100
)

shape2_1.bezierCurveTo(
  -4.100, 6.900,
  -3.300, 5.400,
  -3.600, 3.700
)

shape2_1.bezierCurveTo(
  -3.800, 2.800,
  -4.000, 1.900,
  -4.200, 1.100
)

shape2_1.bezierCurveTo(
  -2.700, 0.500,
  -1.200, 0.200,
  0.300, 0.300
)

shape2_1.lineTo(0.300, -7.600)
shape2_1.lineTo(0.300, -7.600)

shape2_1.bezierCurveTo(
  -3.000, -13.000,
  -6.300, -18.300,
  -9.500, -23.500
)

shape2_1.lineTo(-9.200, -23.800)

shape2_1.bezierCurveTo(
  -7.300, -22.800,
  -5.500, -21.700,
  -3.600, -20.700
)

shape2_1.lineTo(-4.000, -20.400)
shape2_1.closePath()

const shape3_1 = new Shape()

shape3_1.moveTo(-27.800, -9.900)
shape3_1.lineTo(-20.800, -9.900)

shape3_1.bezierCurveTo(
  -20.900, -12.700,
  -20.900, -15.400,
  -20.900, -18.200
)

shape3_1.bezierCurveTo(
  -19.400, -16.900,
  -17.900, -15.500,
  -16.400, -14.200
)

shape3_1.lineTo(-16.400, -29.600)
shape3_1.lineTo(-20.700, -29.600)

shape3_1.bezierCurveTo(
  -20.700, -29.000,
  -20.800, -28.400,
  -21.100, -27.900
)

shape3_1.bezierCurveTo(
  -22.300, -25.700,
  -25.100, -24.800,
  -27.600, -26.400
)

shape3_1.bezierCurveTo(
  -28.700, -27.100,
  -29.400, -28.300,
  -29.400, -29.600
)

shape3_1.lineTo(-35.400, -29.600)

shape3_1.bezierCurveTo(
  -35.400, -29.200,
  -35.400, -28.700,
  -35.300, -28.200
)

shape3_1.bezierCurveTo(
  -34.800, -25.500,
  -33.700, -23.400,
  -31.400, -22.000
)

shape3_1.bezierCurveTo(
  -30.200, -21.300,
  -29.000, -20.900,
  -27.800, -20.200
)

shape3_1.bezierCurveTo(
  -27.500, -20.000,
  -27.100, -19.600,
  -27.100, -19.300
)

shape3_1.bezierCurveTo(
  -27.300, -16.400,
  -27.700, -13.500,
  -27.800, -10.600
)

shape3_1.lineTo(-27.800, -9.900)
shape3_1.closePath()

const shape4_1 = new Shape()

shape4_1.moveTo(4.800, 24.200)

shape4_1.bezierCurveTo(
  6.800, 23.900,
  8.700, 23.300,
  10.100, 21.600
)

shape4_1.bezierCurveTo(
  10.800, 20.800,
  11.500, 20.000,
  12.300, 19.200
)

shape4_1.bezierCurveTo(
  14.100, 24.500,
  12.700, 28.500,
  7.900, 31.300
)

shape4_1.bezierCurveTo(
  9.600, 31.000,
  11.200, 30.800,
  13.200, 30.500
)

shape4_1.bezierCurveTo(
  11.600, 33.200,
  10.100, 35.700,
  8.600, 38.100
)

shape4_1.bezierCurveTo(
  8.600, 38.100,
  8.000, 38.100,
  7.900, 38.100
)

shape4_1.bezierCurveTo(
  7.500, 37.700,
  7.200, 37.300,
  6.800, 36.800
)

shape4_1.bezierCurveTo(
  5.100, 38.900,
  3.600, 40.700,
  2.000, 42.600
)

shape4_1.bezierCurveTo(
  1.300, 43.400,
  0.700, 44.200,
  0.100, 45.000
)

shape4_1.lineTo(0.100, 24.600)

shape4_1.bezierCurveTo(
  1.700, 24.600,
  3.300, 24.400,
  4.900, 24.200
)

shape4_1.lineTo(4.900, 24.200)
shape4_1.closePath()

const shape5_1 = new Shape()

shape5_1.moveTo(4.000, -20.400)

shape5_1.bezierCurveTo(
  2.700, -19.600,
  1.300, -19.200,
  0.000, -19.200
)

shape5_1.lineTo(0.000, -32.200)

shape5_1.bezierCurveTo(
  1.400, -32.200,
  2.800, -32.200,
  4.100, -32.100
)

shape5_1.bezierCurveTo(
  6.300, -32.100,
  8.500, -32.000,
  10.600, -31.900
)

shape5_1.bezierCurveTo(
  11.000, -31.900,
  11.500, -31.800,
  11.900, -31.700
)

shape5_1.bezierCurveTo(
  13.100, -31.700,
  14.300, -31.700,
  15.100, -32.900
)

shape5_1.bezierCurveTo(
  15.800, -33.900,
  16.400, -35.100,
  17.300, -36.000
)

shape5_1.bezierCurveTo(
  20.200, -38.900,
  23.800, -40.000,
  27.800, -38.900
)

shape5_1.bezierCurveTo(
  29.900, -38.400,
  31.800, -37.300,
  33.200, -35.600
)

shape5_1.bezierCurveTo(
  34.700, -33.800,
  35.400, -31.800,
  35.400, -29.500
)

shape5_1.lineTo(29.400, -29.500)

shape5_1.bezierCurveTo(
  29.400, -30.200,
  29.200, -30.800,
  28.800, -31.500
)

shape5_1.bezierCurveTo(
  27.800, -33.200,
  25.000, -34.200,
  22.800, -32.900
)

shape5_1.bezierCurveTo(
  21.300, -32.000,
  20.700, -30.700,
  20.700, -29.500
)

shape5_1.lineTo(16.400, -29.500)
shape5_1.lineTo(16.400, -14.100)

shape5_1.bezierCurveTo(
  13.800, -11.800,
  11.200, -9.500,
  8.600, -7.200
)

shape5_1.lineTo(8.600, -7.000)

shape5_1.bezierCurveTo(
  11.700, -7.000,
  14.800, -7.000,
  17.800, -7.000
)

shape5_1.bezierCurveTo(
  20.800, -7.000,
  20.400, -8.600,
  20.700, -10.000
)

shape5_1.lineTo(27.700, -10.000)

shape5_1.bezierCurveTo(
  27.700, -6.600,
  27.700, -3.300,
  27.500, 0.000
)

shape5_1.bezierCurveTo(
  27.500, 2.200,
  27.000, 4.300,
  26.700, 6.500
)

shape5_1.bezierCurveTo(
  26.700, 7.100,
  26.300, 7.800,
  26.100, 8.400
)

shape5_1.lineTo(25.900, 8.400)

shape5_1.bezierCurveTo(
  25.000, 5.200,
  24.100, 2.000,
  23.300, -1.200
)

shape5_1.lineTo(23.000, -1.200)

shape5_1.bezierCurveTo(
  22.200, 2.100,
  21.400, 5.400,
  20.600, 8.900
)

shape5_1.bezierCurveTo(
  19.300, 7.800,
  18.200, 6.900,
  17.100, 5.900
)

shape5_1.bezierCurveTo(
  17.100, 5.900,
  16.900, 5.600,
  16.700, 5.500
)

shape5_1.lineTo(16.500, 5.500)

shape5_1.bezierCurveTo(
  16.500, 5.700,
  16.700, 5.800,
  16.800, 6.000
)

shape5_1.lineTo(16.800, 7.700)

shape5_1.bezierCurveTo(
  17.200, 9.400,
  16.800, 11.000,
  16.400, 12.600
)

shape5_1.bezierCurveTo(
  16.000, 14.000,
  15.300, 15.200,
  13.800, 15.800
)

shape5_1.bezierCurveTo(
  13.800, 15.300,
  13.600, 14.900,
  13.500, 14.500
)

shape5_1.bezierCurveTo(
  12.500, 10.500,
  10.400, 7.600,
  5.900, 7.100
)

shape5_1.bezierCurveTo(
  4.100, 6.900,
  3.300, 5.400,
  3.600, 3.700
)

shape5_1.bezierCurveTo(
  3.800, 2.800,
  4.000, 1.900,
  4.200, 1.100
)

shape5_1.bezierCurveTo(
  2.700, 0.500,
  1.200, 0.200,
  -0.300, 0.300
)

shape5_1.lineTo(-0.300, -7.600)
shape5_1.lineTo(-0.300, -7.600)

shape5_1.bezierCurveTo(
  3.000, -13.000,
  6.300, -18.300,
  9.500, -23.500
)

shape5_1.lineTo(9.200, -23.800)

shape5_1.bezierCurveTo(
  7.300, -22.800,
  5.500, -21.700,
  3.600, -20.700
)

shape5_1.lineTo(4.000, -20.400)
shape5_1.closePath()

const shape6_1 = new Shape()

shape6_1.moveTo(27.800, -9.900)
shape6_1.lineTo(20.800, -9.900)

shape6_1.bezierCurveTo(
  20.800, -12.700,
  20.800, -15.400,
  20.800, -18.200
)

shape6_1.bezierCurveTo(
  19.300, -16.900,
  17.800, -15.500,
  16.300, -14.200
)

shape6_1.lineTo(16.300, -29.600)
shape6_1.lineTo(20.600, -29.600)

shape6_1.bezierCurveTo(
  20.600, -29.000,
  20.600, -28.400,
  21.000, -27.900
)

shape6_1.bezierCurveTo(
  22.200, -25.700,
  25.000, -24.800,
  27.500, -26.400
)

shape6_1.bezierCurveTo(
  28.600, -27.100,
  29.300, -28.300,
  29.300, -29.600
)

shape6_1.lineTo(35.300, -29.600)

shape6_1.bezierCurveTo(
  35.300, -29.200,
  35.300, -28.700,
  35.300, -28.200
)

shape6_1.bezierCurveTo(
  34.800, -25.500,
  33.700, -23.400,
  31.400, -22.000
)

shape6_1.bezierCurveTo(
  30.200, -21.300,
  29.000, -20.900,
  27.800, -20.200
)

shape6_1.bezierCurveTo(
  27.500, -20.000,
  27.100, -19.600,
  27.100, -19.300
)

shape6_1.bezierCurveTo(
  27.300, -16.400,
  27.700, -13.500,
  27.800, -10.600
)

shape6_1.bezierCurveTo(
  27.800, -10.400,
  27.800, -10.100,
  27.800, -9.900
)

shape6_1.closePath()

const geometries = [
  new ShapeGeometry(shape1_1),
  new ShapeGeometry(shape2_1),
  new ShapeGeometry(shape3_1),
  new ShapeGeometry(shape4_1),
  new ShapeGeometry(shape5_1),
  new ShapeGeometry(shape6_1)
]

const mergedGeometry = BufferGeometryUtils.mergeGeometries(geometries)

// flip Y to match SVG coordinate system
mergedGeometry.scale(0.018, -0.018, 0.018)

export default mergedGeometry
